module.exports = " <div class=\"row wrapper-flexbox no-margin\"> <div class=col-sm-6> <img class=img-responsive src=" + require("../images/mueble.png") + " alt=\"not found\"> </div> <div class=col-sm-6> <div class=bottom-box> <p class=\"text-bg text-center text-uppercase\">¡Ups!</p> <p class=\"text-404 text-center\">No encontramos la página que estabas buscando</p> <button class=\"btn btn-black center-block\" v-link=\"{ path: '/home' }\">Regresar a home</button> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 568
// module chunks = 0